import type { TradeInAemCheckboxType, TradeInAemContactFormId, TradeInAemTextInputType } from "../../utils/constants";
import {
    type TradeInAemContactFormActions,
    TRADE_IN_AEM_CONTACT_FORM_INIT,
    TRADE_IN_AEM_CONTACT_SET_CHECKBOX_ITEM,
    TRADE_IN_AEM_CONTACT_SET_TEXT_ITEM,
} from "../actions/TradeInAemContactFormActions";

export type TradeInAemContactFormReducerType = {
    initialized: boolean;
    [TradeInAemContactFormId.FirstName]?: TradeInAemTextInputType;
    [TradeInAemContactFormId.FirstLastName]?: TradeInAemTextInputType;
    [TradeInAemContactFormId.SecondLastName]?: TradeInAemTextInputType;
    [TradeInAemContactFormId.Address]?: TradeInAemTextInputType;
    [TradeInAemContactFormId.HouseNumber]?: TradeInAemTextInputType;
    [TradeInAemContactFormId.PostalCode]?: TradeInAemTextInputType;
    [TradeInAemContactFormId.City]?: TradeInAemTextInputType;
    [TradeInAemContactFormId.Email]?: TradeInAemTextInputType;
    [TradeInAemContactFormId.Phone]?: TradeInAemTextInputType;
    [TradeInAemContactFormId.PrivacyDisclaimers]?: TradeInAemCheckboxType;
};

export const initialStateTradeInAemContactForm: TradeInAemContactFormReducerType = {
    initialized: false,
};

const TradeInAemContactFormReducer = (
    state: TradeInAemContactFormReducerType = initialStateTradeInAemContactForm,
    action: TradeInAemContactFormActions,
): TradeInAemContactFormReducerType => {
    switch (action.type) {
        case TRADE_IN_AEM_CONTACT_FORM_INIT:
            return { ...state, ...action.initState, initialized: true };

        case TRADE_IN_AEM_CONTACT_SET_TEXT_ITEM: {
            const { value, formItemId } = action;
            if (state[formItemId]) {
                return { ...state, [formItemId]: { ...state[formItemId], value } };
            }
            return state;
        }

        case TRADE_IN_AEM_CONTACT_SET_CHECKBOX_ITEM: {
            const { value, selected, formItemId } = action;
            if (state[formItemId]) {
                const newItems = state[formItemId]!.items.map((item) => ({
                    ...item,
                    selected: value === item.value ? selected : item.selected,
                    interacted: value === item.value ? true : item.interacted,
                }));

                return { ...state, [formItemId]: { ...state[formItemId]!, items: newItems } };
            }
            return state;
        }

        default:
            return state;
    }
};

export default TradeInAemContactFormReducer;
